<!-- 收藏夹图像盒子 -->
<template>
  <div
    class="ibox2"
    @mouseover="showAddFavoriteBn"
    @mouseleave="hideAddFavoriteBn"
  >
    <div @click="openBigImg" class="iimg2">
      <el-tooltip
        style="width:100%;"
        class="item"
        effect="dark"
        :content="isrc"
        placement="top-start"
      >
        <el-image :alt="iname" :src="home_url"></el-image>
      </el-tooltip>
    </div>
    <div class="iname2">
      {{ iname }}
    </div>
    <span
      @click="delFavorite"
      title="移除收藏"
      v-if="showFavorite"
      id="delFavor"
    >
      <el-button
        type="danger"
        icon="el-icon-star-off"
        circle
        size="mini"
      ></el-button>
    </span>
  </div>
</template>

<script>
import config from '@/util/config'
// const imgurl = '/md/front/paid/img/'
export default {
  emits: ['delEvent'],
  props: {
    fid: Number,
    imgId: String,
    imgInfo: String,
    index: String
  },
  data () {
    return {
      // home_url: imgurl + '/samllimg/' + this.imgId + '/1',
      home_url: config.small_img_url + this.imgId + '.jpg',
      showFavorite: false,
      isAdd: false, // 是否已经被添加到收藏
      iname: '',
      isrc: '',
      idraw: '',
      imark: '',
      posSrc: '',
      lenSrc: '',
      label: '',
      level: ''
    }
  },
  methods: {
    hideAddFavoriteBn () {
      this.showFavorite = false
    },
    showAddFavoriteBn () {
      if (!this.isAdd) {
        this.showFavorite = true
      }
    },
    del (id) {
      const index = this.list.findIndex(item => {
        if (item.id === id) {
          return true
        }
      })
      this.list.splice(index, 1)
    },
    delFavorite () {
      this.$emit('delEvent', this.fid)
    },
    openBigImg: async function () {
      if ((await this.judgeNowUserHasPowerOrNotFun()) === false) {
        return
      }
      // const imginfo = this.iname + ':' + this.isrc + ':' + this.idraw + ':' + this.imark + ':'
      // this.imgInfo = imginfo + this.iClass + ':' + this.titleG + ':' + this.clearBG + ':' // 新增的3个属性
      this.$store.commit('setGlobalObjOfShowImgID', this.imgId)
      this.$store.commit('setGlobalObjOfShowImgInfo', this.imgInfo)
      this.$router
        .push({
          path: '/imgList/convas',
          query: {
            showImage: true,
            fromRoutePath: encodeURIComponent('/userCenter/collection')
          }
        })
        .catch(() => {})
    },
    judgeNowUserHasPowerOrNotFun: async function () {
      const api = '/md/front/paid/image/multiSearch'
      const res = await this.axios.post(api)
      if (res.status !== 200) {
        return false
      }
      if (res.data.flag) {
        return true
      } else {
        this.$alert(res.data.info, '提示')
        return false
      }
    }
  },
  mounted () {
    // "400001900006:祠左書屋圖:篁墩程朱闕里祠志8卷清徐光文等清乾隆愛餘書屋刻本:null:null:"
    const strArray = this.imgInfo.split(':')
    debugger
    if (strArray.length === 8) {
      this.iname = strArray[0]
      this.isrc = strArray[1].replaceAll('@', ' ')
      if (strArray[2] !== 'null') {
        this.idraw = strArray[2]
      } else {
        this.idraw = ''
      }
      if (strArray[3] !== 'null') {
        this.imark = strArray[3]
      } else {
        this.imark = ''
      }
      this.home_url = config.small_img_url + this.imgId + '.jpg'
    }
  }
}
</script>
<style scoped>
#delFavor {
  position: absolute;
  right: 6px;
  top: 6px;
  cursor: pointer;
  font-size: 30px; /*控制ui 图标的大小*/
}

.ibox2 {
  width: 95%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #963;
  -moz-box-shadow: 2px 2px 5px #333333;
  -webkit-box-shadow: 2px 2px 5px #333333;
  box-shadow: 2px 2px 5px #333333;
  position: relative;
  background-color: #fff;
}
.iname2 {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #666;
  text-align: center;
  font-size: 15px;
  margin-bottom: 8px;
}

.iimg2 {
  width: 100%;
  height: 110px;
  text-align: center;
  margin-top: 10px;
  overflow: hidden;
}
</style>
